/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';

const style = css({
  maxWidth: '700px',
  padding: '15px',
  marginBottom: '15px',
});
/**
 * フォームのコンテンツ
 */
const FormContentFilter: React.FC<{
  customStyles?:any
}> = ({
  children,customStyles
}) => (
  <div css={css(style,customStyles)}>
    {children}
  </div>
);

export default FormContentFilter;
